var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSummaryViewBlue = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7066_7165)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 1.5C10.2334 1.5 11.4477 1.80418 12.5355 2.38559C13.6232 2.967 14.5508 3.8077 15.236 4.83322C15.9213 5.85874 16.343 7.03743 16.4639 8.26487C16.5848 9.49231 16.4011 10.7306 15.9291 11.8701M9 1.5V5.27672M9 1.5C7.51664 1.5 6.0666 1.93987 4.83323 2.76398C3.59986 3.58809 2.63856 4.75943 2.07091 6.12987C1.50325 7.50032 1.35472 9.00832 1.64411 10.4632C1.9335 11.918 2.64781 13.2544 3.6967 14.3033M15.9291 11.8701C15.4571 13.0096 14.7114 14.0151 13.758 14.7976C12.8045 15.58 11.6729 16.1153 10.4632 16.3559C9.2535 16.5965 8.00314 16.5351 6.82287 16.1771C5.6426 15.819 4.56884 15.1754 3.6967 14.3033M15.9291 11.8701C16.306 10.9602 16.5 9.98491 16.5 9H12.7233C12.7233 9.48895 12.627 9.97311 12.4399 10.4248M15.9291 11.8701C15.5522 12.7801 14.9997 13.6069 14.3033 14.3033L11.6328 11.6328C11.9785 11.287 12.2528 10.8766 12.4399 10.4248M3.6967 14.3033L6.36725 11.6328M6.36725 11.6328C6.80021 12.0657 7.33326 12.3852 7.91919 12.563C8.50513 12.7407 9.12585 12.7712 9.72638 12.6517C10.3269 12.5323 10.8887 12.2666 11.362 11.8781C11.8353 11.4897 12.2055 10.9905 12.4399 10.4248M6.36725 11.6328C5.84654 11.112 5.49193 10.4486 5.34827 9.72638C5.20461 9.00413 5.27834 8.2555 5.56014 7.57516C5.84195 6.89482 6.31917 6.31333 6.93146 5.90421C7.54375 5.49509 8.26361 5.27672 9 5.27672M12.4399 10.4248C12.6742 9.85915 12.7654 9.2444 12.7054 8.63505C12.6453 8.02571 12.436 7.44056 12.0958 6.93146C11.7556 6.42235 11.2951 6.005 10.7551 5.71636C10.2151 5.42773 9.6123 5.27672 9 5.27672",
    stroke: "#7BABF5",
    strokeWidth: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7066_7165"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSummaryViewBlue);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/summary_view_blue.48ab23836eb0ee7bd5d2bc9e612abd27.svg";